import {
  addHtmlElementEventListener,
  appendHtmlElementChild,
  EASE_IN_TRANSITION_TIME,
  getHtmlElement,
  obj2string,
  removeHtmlChildren,
  renderWebComponent, setHtmlElementContent,
  string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import { EventBusComponent } from "../EventBusComponent";
import I18n from "i18n-js";


export class SubmissionListAddressComponent extends HTMLElement {
  props = {};
  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }


  connectedCallback() {
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList));
    addHtmlElementEventListener(this.shadowRoot, 'new-address', 'click',
      () =>
        this.eventBus.publish("open-submission-list-addresses-modal",
          {
            address_type: this.props.address_type,
            addresses: this.props.submissionList.addresses
          }
        )
    )
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    if (submissionList[`${this.props.address_type}_address`])
      this.changeAddressToRender(submissionList[`${this.props.address_type}_address`])
    else
      setTimeout(() => this.changeAddressToRender(submissionList[`${this.props.address_type}_address`]), EASE_IN_TRANSITION_TIME)
    this.props.submissionList = { ...submissionList};

    if (this.props.submissionList[`${this.props.address_type}_address`])
      setHtmlElementContent(this.shadowRoot, 'new-address', I18n.t('js.editSubmissionListPage.webComponent.draft.changeAddress'))
    else
      setHtmlElementContent(this.shadowRoot, 'new-address', I18n.t('js.editSubmissionListPage.webComponent.draft.newAddress'))
  }


  // Funzione che aggiorna l'interfaccia grafica renderizzando un nuovo indirizzo
  changeAddressToRender(newAddress) {
    removeHtmlChildren(getHtmlElement(this.shadowRoot, this.props.address_type + '_address_container'))
    const template = document.createElement('template');
    template.innerHTML = `
      ${
        newAddress ?
          `<div>
            <address-component
              props='${obj2string({
                address: newAddress
              })}'
            ></address-component>
          </div>`
          :
          `<div>
            ${I18n.t('js.newUserAddressForm.noAddress')}
          </div>`
      }
    `

    appendHtmlElementChild(getHtmlElement(this.shadowRoot, this.props.address_type + '_address_container'), template.content.cloneNode(true))
  }



  render() {
    const html = `
      <div class="row mx-0 br-4px">        
        <div id=${this.props.address_type + '_address_container'}
          class="col-12 text-left pl-0 py-1" 
        ></div>
        
        <div class="row d-flex justify-content-start w-100 pb-1 pl-3">
          <span class="text-aiBlue text-underline-imp cursor-pointer" id="new-address">
            ${this.props.submissionList[`${this.props.address_type}_address`] ? I18n.t('js.editSubmissionListPage.webComponent.draft.changeAddress') : I18n.t('js.editSubmissionListPage.webComponent.draft.newAddress')}
          </span>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, styles]);

    this.changeAddressToRender(this.props.submissionList[`${this.props.address_type}_address`]);
  }
}

window.customElements.define("submission-list-address-component", SubmissionListAddressComponent);